import type { EditorState } from "prosemirror-state";
import type { Mark } from "prosemirror-model";
import getLinkRange from "./getLinkRange";

export default function isLinkActive(state: EditorState) {
  const { selection, schema } = state;
  const linkType = schema.marks.link;

  if (selection.empty) {
    const range = getLinkRange(state);
    return range !== null;
  }

  let found: Mark | null = null;
  let hasInconsistentLinks = false;

  state.doc.nodesBetween(selection.from, selection.to, (node) => {
    if (!node.isText) return;

    const link = node.marks.find((m) => m.type === linkType);
    if (!link) {
      hasInconsistentLinks = true;
      return false;
    }

    if (!found) {
      found = link;
    } else if (found.attrs.href !== link.attrs.href) {
      hasInconsistentLinks = true;
      return false;
    }
  });

  return found !== null && !hasInconsistentLinks;
}
